<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addGoodsCategory">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        ref="dragTable"
        :scroll="{ y: 'calc(100vh - 345px)' }"
        childrenColumnName="[]"
        row-key="id"
        :data-source="table.data"
        :loading="table.loading"
        :columns="table.columns">
        <template slot="seriesId" slot-scope="text, record">
          <span>{{ getSeriesName(record.series) }}</span>
        </template>
        <span slot="img" slot-scope="text, record">
           <a-avatar :size="80" shape="square" :src="record.coverPath"/>
          </span>
        <template slot="sort">
          <a-icon type="drag" style="font-size: 25px;"/>
        </template>
        <template slot-scope="text, record" slot="action">
          <a-button type="link" @click="viewGoodsCategory(record.id)">详情
          </a-button>
          <a-button type="link" @click="editGoodsCategory(record.id)">{{ $t('EDIT') || '编辑' }}
          </a-button>
          <a-button type="link" @click="deleteGoodsCategory(record.id)">{{ $t('DELETE') || '删除' }}
          </a-button>
        </template>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="商品分类编辑"
      v-model="form.visible">
      <website-goods-category-edit
        v-if="form.visible"
        :goods-category-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-goods-category-edit>
    </a-modal>
    <a-modal
      :footer="null"
      title="商品属性"
      append-to-body
      v-model="attributeForm.visible">
      <goods-attribute-list
        v-if="attributeForm.visible"
        :goods-category-id="attributeForm.data.id">
      </goods-attribute-list>
    </a-modal>
  </a-card>
</template>

<script>
import { _deleteGoodsCategory, _queryGoodsCategories, _updateGoodsSort, } from '@/api/websiteGoodsCategoryApi';
import WebsiteGoodsCategoryEdit from './WebsiteGoodsCategoryEdit.vue';
import GoodsAttributeList from '../../shop/goodsAttribute/GoodsAttributeList.vue';
import Sortable from 'sortablejs';

function getSeriesName(series) {
  if (series === null || series === 'null' || series.name === null || series.name === '') {
    return 'ALL';
  }
  return series.name;
}

async function getGoodsCategoryList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryGoodsCategories({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content.filter(x => !x.parentId)
    .map(x => (
      {
        ...x,
        children: getChildren(result.content, x.id),
      }
    ));
  this.table.data.forEach(element => {
    if (element.children.length === 0) {
      delete element.children;
    }
  });
  const list = this.table.data;
  this.table.data = list;
  this.table.loading = false;
}

function editGoodsAttribute(id) {
  this.attributeForm.data.id = id;
  this.attributeForm.visible = true;
}

function addGoodsCategory() {
  this.form.data.id = null;
  this.form.visible = true;
}

function getChildren(categoryList, parentId) {
  const secondlist = categoryList.filter(x => x.parentId === parentId).map(x => ({
    ...x,
    children: categoryList.filter(y => y.parentId === x.id)
  }));
  // 根据是否含有children 来决定是否删除该属性
  secondlist.forEach(element => {
    if (element.children.length === 0) {
      delete element.children;
    }
  });
  return secondlist;
}

function editGoodsCategory(goodsCategoryId) {
  this.form.data.id = goodsCategoryId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getGoodsCategoryList();
}

function viewGoodsCategory(categoryId) {
  this.$router.push(`/website-category/${categoryId}`);
}

async function deleteGoodsCategory(goodsCategoryId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteGoodsCategory(goodsCategoryId);
      if (result) {
        this.$message.success('删除成功');
        this.getGoodsCategoryList();
      }
    },
  });
}

function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(4)',
    animation: 150,
    // 利用更新
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) {
        return
      }
      this.updateSortList(oldIndex, newIndex)
    },

  })
}

async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateGoodsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.getGoodsCategoryList()
  }
}

const columns = [
  {
    title: '系列',
    dataIndex: 'seriesId',
    ellipsis: true,
    scopedSlots: { customRender: 'seriesId' },
  },
  {
    title: '标题',
    dataIndex: 'name',
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '拖拽排序',
    dataIndex: 'id',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'WebsiteGoodsCategoryList',
  components: {
    GoodsAttributeList,
    WebsiteGoodsCategoryEdit,
  },
  data() {
    return {
      expandedRowKeys: [],
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      attributeForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        columns: columns,
        data: [],
        query: {
          page: 1,
          size: 999,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getSeriesName,
    getGoodsCategoryList,
    editGoodsAttribute,
    deleteGoodsCategory,
    editGoodsCategory,
    addGoodsCategory,
    closeForm,
    viewGoodsCategory,
    initSortable,
    updateSortList,
  },
  mounted() {
    this.initSortable();
  },
  created() {
    this.getGoodsCategoryList();
  },
};
</script>

<style scoped>

</style>
